import { Button, ButtonVariant, Icon, Popover, Position, Tag } from "@blueprintjs/core"
import { Fragment, useEffect, useState } from "react"
import { ID, POST_STATUS } from "src/libs/interfaces/layouts"
import { Hint } from "src/libs/useful"
import RatingHandler from "src/libs/useful/RatingHandler"
import { __, getColumnClassName, getContrastColor, getDomainName } from "src/libs/utilities"
import { IFeedProps } from "src/modules/pe-basic-module/views/core/FeedComponent"
import { ILandingCategory, ILink } from "src/modules/pe-landing-module/data/interfaces"
import { useLandingStore, useLandingConsoleStore, ILandingConsoleStore } from "src/modules/pe-landing-module/data/store"
import { IUser } from "src/settings/zustand"
import { LINK_POST_TYPES } from "../LinksFeedPrimitive"
import LinkItemEditForm from "./LinkItemEditForm"
import { getAvrRating, THUMBNAIL_SIZE } from "./SingleLink"
import isFeedAuthor from "./isFeedAuthor"
import actions from "src/modules/pe-basic-module/data/actions"
import { UPDATE_SINGLE_TYPE } from "src/modules/pe-basic-module/data/actionTypes"

/* Protopia Ecosystem component */
export interface ILinkFeedCardProps extends IFeedProps {
   params: any
}
const LinkFeedCard = (props: ILinkFeedCardProps): JSX.Element => {
    const isEdit = useLandingConsoleStore((state: ILandingConsoleStore) => state.isEdit )
    const [categories, setCats] = useState<ILandingCategory[]>( [] )
    const [rating, setRating] = useState<any[]>( props.item.rating || [] )
    const [isRatingUpdate, setIsRatingUpdate] = useState<boolean>( false )
    const [avRating, setAvRating] = useState<number>( getAvrRating(props.item.rating || []) )

    useEffect(() => {
        const cats = useLandingStore.getState().currentLanding?.categories || []
        setCats(cats)
        setRating( props.item.rating || [] )
        setAvRating( getAvrRating(props.item.rating || []) )
    }, [ props.item.categoryId, props.item.rating ])

    const getCategory = (id: ID): ILandingCategory | undefined => {
        return categories.find( c => c.id === id )
    }

    const onStatus = ( evt: any, post_status: POST_STATUS ) => {
        props.params.onChange( post_status, "post_status", props.item )        
        evt.stopPropagation()
        evt.preventDefault()
    }
    
    const onRating = (user: IUser, rate: number) => { 
        props.params.onChange( [{ user: user.id, rating: rate }], "rating", props.item ) 
    }
    const onAdd = ( item: ILink ) => { 
        console.log(item) 
        props.params.onAdd( item, item.id  )        
    } 
    const doDelete = ( ) => {  
        props.params.doDelete( props.item  )        
    } 

    const isActive: boolean = isFeedAuthor( props.params.primitive )
    const col = getColumnClassName( props.params.col )
    return <div className={`pe-single-link-container mb-3 position-relative d-flex w-100 flex-sm-column flex-lg-row align-items-start ${ col }`}> 
        <>
            <div
                style={{
                    width: THUMBNAIL_SIZE, 
                    position: "relative", 
                    marginRight: 20,
                    marginBottom: 4,
                }}
            >
                <a
                    style={{
                        width: THUMBNAIL_SIZE, 
                        height: THUMBNAIL_SIZE,
                        display:"block",
                        position: "relative",
                        backgroundImage:`url(${ props.item.image })`,
                        backgroundSize: "cover",
                        backgroundPosition: "center", 
                        aspectRatio: 1,
                    }}
                    className={`${ props.item.post_status === POST_STATUS.DRAFT ? "opacity_5" : "" }`}
                    href={props.item.url} 
                    target="_blank" 
                    rel="noreferrer"                        
                > 
                    
                </a>
                {    
                    props.params.primitive.isRating && <>
                        <RatingHandler 
                            rating={ rating }
                            current={ avRating } 
                            isLoading={ isRatingUpdate }
                            isActive={ isActive }
                            onChange={ onRating } 
                            size={ 10 } 
                            max={ 5 }
                            color={"var(--force-contrast-opacity-color"} 
                            activeColor={"var(--red"} 
                            className="mt-2" 
                        />
                    </>
                }
                {
                    props.params.primitive.isStatusFiltered && <>
                        <div className="d-flex position-relative ">
                            {
                            
                                isActive && LINK_POST_TYPES.map( key => <Hint label={ __( key.title ) } key={ key._id }>
                                        <Button
                                            variant={ ButtonVariant.MINIMAL }
                                            icon={ key.icon } 
                                            className={`mr-1 ${ props.item.post_status === key._id ? "" : "opacity_5"} `}
                                            onClick={ (evt: any) => onStatus(evt, key._id) }
                                        />
                                    </Hint>)
                            }
                        </div>
                    </>
                }
                
            </div>
            <div className={`w-100 ${ props.item.post_status === POST_STATUS.DRAFT ? "opacity_5" : "" } `}>
                <a className="title mb-2" href={props.item.url} target="_blank" rel="noreferrer" dangerouslySetInnerHTML={{__html: props.item.title || ""}} />
                <div>
                    { props.item.post_content }
                </div>
                <div className="d-flex justify-content-start mt-1">
                    { 
                        props.item.categoryId?.map((id: ID, i: number) => {
                            const tag = getCategory( id )
                            return !!tag 
                                ? 
                                !!tag.content
                                    ?
                                    <Popover 
                                        key={ tag.id }
                                        position={ Position.TOP_LEFT }
                                        interactionKind="hover"
                                        hoverOpenDelay={ 750 }
                                        content={
                                            <div className="width-300 overflow-y-auto">
                                                <div className="small p-4">
                                                    { tag.content }
                                                </div>
                                            </div>
                                        }
                                    >
                                        <Tag style={{ backgroundColor: tag.color }} className="text-uppercase letter-spacing-2 px-2 py-1 mr-1 mb-1">
                                            <span style={{ color: getContrastColor( tag.color ) }} className="smallest" dangerouslySetInnerHTML={{__html: tag.title}} />
                                            <Icon icon="caret-down" size={12} className="ml-2" />
                                        </Tag>
                                    </Popover>
                                    :                              
                                    <Tag key={ tag.id } style={{ backgroundColor: tag.color }} className="text-uppercase letter-spacing-2 px-2 py-1 mr-1 mb-1">
                                        <span style={{ color: getContrastColor( tag.color ) }} className="smallest" dangerouslySetInnerHTML={{__html: tag.title}} />
                                    </Tag>  
                                : 
                                <Fragment key={ i } />
                        })
                    }
                </div>
                <div className="d-flex justify-content-start mt-1">
                    <a href={props.item.url} target="_blank" rel="noreferrer" >
                        <div className="small">{ getDomainName( props.item.url ) ||  __("Link")}</div>
                    </a>
                </div>
            </div>
        </> 
        {
            isActive && isEdit && <LinkItemEditForm 
                item={props.item}
                i={ props.params.items.findIndex( (item: ILink) => item.url  === props.item.url ) }  
                items={ props.params.items }   
                onAdd={ onAdd }
                onUpdate={ onAdd } 
                doDelete={ doDelete } 
            />
        }
        
    </div>
}
export default LinkFeedCard